import { GITHUB, LINKED_IN } from "../utils/constants";

export default function Footer() {
    return (
        <footer className="border-t-customGrey border-t-[1px]">
            <div className="flex flex-col">
                <div className="max-w-[1440px] mx-auto w-full px-[20px] py-[30px]">
                    <div className="flex flex-col gap-[30px] sm:flex-row sm:items-center justify-between">
                        <div className="flex flex-col gap-[10px]">
                            <a
                                className="font-mediums text-lg md:text-2xl"
                                href="mailto:mariya.kovalenko.2000@gmail.com"
                            >
                                mariya.kovalenko.2000@gmail.com
                            </a>
                            <p className="text-customDarkGrey">
                                For any questions or job offers <br></br>
                                contact me via
                                email!
                            </p>
                        </div>
                        <div className="footer-atc">
                            <a
                                href="/CV_Updated.pdf"
                                download
                                className="h-[45px] flex items-center justify-center bg-black rounded-lg text-white w-full sm:w-[240px] py-[10px] px-4 "
                            >
                                Download CV
                            </a>
                        </div>
                    </div>
                </div>

                <div className=" border-t-customGrey border-t-[1px]">
                    <div className="max-w-[1440px] mx-auto w-full flex justify-between items-center">
                        <div className="flex items-center gap-[15px] pl-[20px]">
                            <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="40"
                                    height="40"
                                    rx="20"
                                    fill="#B983FF"
                                />
                                <path
                                    d="M7.88068 13.8636H11.3636L14.3182 21.0682H14.4545L17.4091 13.8636H20.892V25.5H18.1534V18.3523H18.0568L15.2614 25.4261H13.5114L10.7159 18.3125H10.6193V25.5H7.88068V13.8636ZM22.2656 16.1477V13.8636H32.1009V16.1477H28.5724V25.5H25.7997V16.1477H22.2656Z"
                                    fill="white"
                                />
                            </svg>
                            <p className="text-customDarkGrey text-sm md:text-base">
                                © Mariia Tanchuk 2024
                            </p>
                        </div>

                        <div className="border-l-customGrey border-l-[1px] flex gap-[20px] items-center p-[20px] pl-[40px] min-h-full">
                            <a href={LINKED_IN} target="_blank">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_7_15)">
                                        <path
                                            d="M24 23.469V14.595C24 9.84002 21.462 7.62752 18.078 7.62752C15.3472 7.62752 14.1233 9.12977 13.4415 10.1843V7.99127H8.2965C8.36475 9.44402 8.2965 23.469 8.2965 23.469H13.4415V14.8253C13.4415 14.364 13.4745 13.9013 13.611 13.5713C13.9823 12.6465 14.829 11.6895 16.2495 11.6895C18.1117 11.6895 18.8558 13.1085 18.8558 15.189V23.4698L24 23.469ZM2.87625 5.87852C4.6695 5.87852 5.78775 4.68902 5.78775 3.20327C5.75475 1.68527 4.67025 0.530273 2.91075 0.530273C1.15125 0.530273 0 1.68452 0 3.20327C0 4.68902 1.11675 5.87852 2.844 5.87852H2.87625ZM5.44875 23.469V7.99127H0.3045V23.469H5.44875Z"
                                            fill="#B4B4B4"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7_15">
                                            <rect
                                                width="24"
                                                height="24"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                            <a href={GITHUB} target="_blank">
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14 2.62109C11.2297 2.62121 8.54988 3.60706 6.43997 5.40225C4.33006 7.19744 2.92776 9.68482 2.484 12.4193C2.04024 15.1538 2.58397 17.957 4.01789 20.3273C5.45182 22.6976 7.68238 24.4803 10.3105 25.3565C10.8938 25.4586 11.1125 25.1086 11.1125 24.8023C11.1125 24.5253 11.0979 23.6065 11.0979 22.6294C8.16668 23.169 7.40835 21.9149 7.17501 21.2586C6.9161 20.6204 6.50567 20.0548 5.97918 19.6107C5.57084 19.3919 4.98751 18.8523 5.96458 18.8378C6.33767 18.8783 6.6955 19.0081 7.00775 19.2162C7.32 19.4244 7.57747 19.7048 7.75835 20.0336C7.91791 20.3202 8.13247 20.5726 8.38973 20.7762C8.64699 20.9797 8.9419 21.1306 9.25755 21.22C9.5732 21.3094 9.90339 21.3356 10.2292 21.2972C10.555 21.2588 10.87 21.1565 11.1562 20.9961C11.2067 20.403 11.4711 19.8484 11.9 19.4357C9.30418 19.144 6.59168 18.1377 6.59168 13.6753C6.57528 12.5158 7.00314 11.394 7.78751 10.5399C7.43084 9.53214 7.47257 8.42621 7.90418 7.44821C7.90418 7.44821 8.88123 7.14195 11.1125 8.64405C13.0215 8.11901 15.0368 8.11901 16.9458 8.64405C19.1771 7.12738 20.1542 7.44821 20.1542 7.44821C20.5858 8.4262 20.6276 9.53214 20.2708 10.5399C21.0576 11.3925 21.4858 12.5153 21.4667 13.6753C21.4667 18.1523 18.7396 19.144 16.1438 19.4357C16.4222 19.7179 16.6366 20.0567 16.7725 20.4291C16.9084 20.8016 16.9625 21.1989 16.9313 21.594C16.9313 23.1545 16.9167 24.4086 16.9167 24.8024C16.9167 25.1086 17.1354 25.4732 17.7188 25.3565C20.3422 24.4732 22.5663 22.6863 23.9942 20.3148C25.422 17.9433 25.9605 15.1416 25.5137 12.4097C25.0669 9.67785 23.6637 7.19369 21.5547 5.40069C19.4457 3.60769 16.7682 2.62253 14 2.62109Z"
                                        fill="#B4B4B4"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
